import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";

const TextAreaField = ({
  value,
  borderColor,
  name,
  label,
  placeholder,
  required,
  validators,
  type,
  onChange,
  labelClass,
  spanTitle,
  inputClass,
  cols,
  rows,
  readonly,
  disabled,
  getError,
  Error,
  maxLength,
  minLength
}) => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  //const [style, setStyle] = useState({});
  // console.log(validators, "validators");
  const handleChange = (event) => {
    const { value } = event.target;
    if (validateInput(validators, value))
      setError(validateInput(validators, value));
    else if (!validateInput(validators, value) && value !== "") {
      setSuccess(true);
      setError(false);
    } else {
      setError(false);
    }
    onChange(value);
    getError &&
      getError(
        validateInput(validators, value)
          ? validateInput(validators, value)
          : false
      );
  };

  return (
    <>
      {label && (
        <div className={labelClass}>
          <label className="input-textarea">
          {label} {required && <b className={"text-danger"}>*</b>}
          </label>
        </div>
      )}
      <div className={inputClass}>
        <div className="form-group">
          <textarea
            style={{ resize: "none", borderColor:borderColor }}
            name={name}
            type={type}
            className="library-textarea form-control"
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
            readOnly={readonly}
            maxLength={maxLength}
            minLength={minLength}
            rows={rows}
            cols={cols}
            disabled={disabled}
          ></textarea>
          {/* {spanTitle &&
          <span className="spanMovingUp">{spanTitle}</span>
          } */}
          {spanTitle && <small>{spanTitle}</small>}
          {(error || Error && Error[name]) && <span className="text-danger errormsg">{error.message|| Error[name]}</span>}
        </div>
      </div>
    </>
  );
};

TextAreaField.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
};

TextAreaField.defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  type: "text",
  validators: [],
  labelClass: "col-md-4",
  inputClass: "col-md-6",
};
export default TextAreaField;
